import { PipelineType } from "pages/pipelines"

import getPipelinePublicUrl from "./getPipelinePublicUrl"

export default function getPipelineName(pipeline: PipelineType): string {
  const publicUrl = getPipelinePublicUrl(pipeline)

  return publicUrl
    .toString()
    .replace(/^.*:\/\//, "")
    .replace(/\/$/, "")
}
